import {catchError, finalize, map} from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {HttpHandler} from './http-handler';

import {ToolsService} from '../../shared/services/tools/tools.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from '../services/loader.service';
import {AuthentificationService} from '../services/authentification.service';
import * as Sentry from '@sentry/browser';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
    private toolService = inject(ToolsService);
    private router = inject(Router);
    private activatedRouter = inject(ActivatedRoute);
    private loaderService = inject(LoaderService);
    private authService = inject(AuthentificationService);


    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        return next.handle(req).pipe(
            map((event: HttpEvent<any>) => event),
            catchError((error: HttpErrorResponse) => {
                if (error instanceof HttpErrorResponse) {
                    switch (error.status) {
                        case 404: // API OR ITEM introuvable
                            this.toolService.notificationError(
                                'La page ou l\'élément demandé n\'existe pas.',
                                5000
                            );
                            break;
                        case 401: // Non authorisé (Redirection sur la connnexion si non connecté)
                            //window.localStorage.clear();
                            if (this.authService.token) {
                                this.authService.logout();
                            }
                            break;
                        case 500: // Erreur Serveur
                            this.toolService.notificationError(
                                'Une erreur serveur s\'est produite. Contactez un administrateur ',
                                5000
                            );
                            break;
                        case 403: // Erreur Serveur
                            this.toolService.notificationError(
                                '403 : Vous n\'avez pas les droits suffisant pour effectuer cette action.',
                                5000
                            );
                            // En cas de 403 pas les droits, redirection vers la home page.
                            this.router.navigate(['/']);
                            break;
                        case 400: // Bad request
                        case 422: // Validation errors
                            const errorObject = error.error;
                            if (errorObject instanceof Blob) {
                                errorObject.text().then((value: string) => {
                                    this.notifyError(JSON.parse(value));
                                });
                            }else{
                                this.notifyError(errorObject);
                            }
                            break;
                        default:
                            break;
                    }
                }

                const userConnected = this.authService.userConnected;
                if (userConnected) {
                    Sentry.setUser(
                        {
                            id: userConnected.id + '',
                            username: userConnected.email
                        }
                    );
                }

                return throwError(error);
            }),
            finalize(() => {
                if (
                    !(req.url.indexOf('/api/fields/') !== -1) &&
                    !(req.url.indexOf('noLoader') !== -1)
                ) {
                    this.loaderService.removeLoader();
                }
            })
        );
    }


    public extractServerErrorMessage(error): string {
        const errorMessageFallback = 'Une erreur est survenue';

        if (!error['@type']){
            return errorMessageFallback;
        }

        switch(error['@type']){
            case 'hydra:Error':
                return error['hydra:description'] ?? errorMessageFallback;
            case 'ConstraintViolationList':
            case 'ConstraintViolation':
                if (error.violations && error.violations.length) {
                    return error.violations.map(item =>  '• ' + (item.message ?? '')).join('\n');
                }
        }

        return errorMessageFallback;
    }

    private notifyError(error: any) {
        this.toolService.notificationError(
            this.extractServerErrorMessage(error),
            50000
        );
    }
}
